import { useState, useEffect } from 'react';
import { Outlet } from 'react-router';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { Footer } from './Footer';
import { useNotificationRealtimeSubscription } from '@/hooks/useRealtimeSubscription';
import { useGroupsRealtimeSubscription } from '@/hooks/useGroups';
import { usePremium } from '@/hooks/usePremium';
import { Analytics } from '@/services/analytics.service';
import { FREE_FOR_ALL_ENABLED } from '@/config/free-mode';

export function AppShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { tier } = usePremium();

  // Subscribe to notification changes for live badge updates
  useNotificationRealtimeSubscription();
  // Subscribe to group membership changes for live group list updates
  useGroupsRealtimeSubscription();

  // Sync premium status as a super property for all analytics events.
  // Report the REAL tier, not the free-for-all override — during the campaign
  // isPremium is true for everyone, which would break conversion segmentation.
  useEffect(() => {
    Analytics.setSuperProperties({
      Premium: tier !== 'FREE',
      FreeForAll: FREE_FOR_ALL_ENABLED,
    });
  }, [tier]);

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="flex flex-1 flex-col overflow-hidden">
        <Header onMenuClick={() => setSidebarOpen(true)} />

        <main className="flex-1 overflow-auto p-4 lg:p-6">
          <Outlet />
        </main>

        <Footer />
      </div>
    </div>
  );
}
